import { Encoding } from "constants/reports/encoding";
import { FileFormat } from "constants/reports/file-format";
import { IScheduledReportsData } from "store/views/reports/interfaces";

import { getNextReportFromPeriod, getRecursFromPeriod, getReportId, getSourceFromType } from "../helpers";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserializeScheduledReports(rawData: any): IScheduledReportsData {
  const data = {};
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const sortedIds: any = [];

  const reports = rawData.data ? rawData.data : rawData;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reports.result.forEach((report: any) => {
    const { email, encoding, format, name, period, status, type, licence_id } = report;

    const id = getReportId(type, period);
    const source = getSourceFromType(type);
    const recurs = getRecursFromPeriod(period);
    const nextReport = getNextReportFromPeriod(period);
    const fileFormat = encoding === Encoding.Utf16le ? FileFormat.TsvExcel : format;

    sortedIds.push(id);
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    data[id] = {
      id,
      recipients: email,
      format: fileFormat,
      name,
      recurs,
      status,
      source,
      licenceId: licence_id,
      nextReport,
    };
  });

  return {
    data,
    sortedIds,
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function deserializeScheduledReportCreate(rawData: any) {
  const { encoding, email, format, period, status = "scheduled", type, licence_id } = rawData;

  const id = getReportId(type, period);
  const source = getSourceFromType(type);
  const recurs = getRecursFromPeriod(period);
  const nextReport = getNextReportFromPeriod(period);
  const fileFormat = encoding === Encoding.Utf16le ? FileFormat.TsvExcel : format;
  const reportName = `${type}Export`;

  const data = {
    id,
    recipients: email,
    format: fileFormat,
    name: reportName,
    recurs,
    status,
    source,
    licenceId: licence_id,
    nextReport,
  };

  return data;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function deserializeScheduledReportEdit(rawData: any) {
  const { encoding, email, format, name, period, status, type, licence_id, typeCurrent, periodCurrent } = rawData;

  const id = getReportId(type, period);
  const source = getSourceFromType(type);
  const recurs = getRecursFromPeriod(period);
  const nextReport = getNextReportFromPeriod(period);
  const fileFormat = encoding === Encoding.Utf16le ? FileFormat.TsvExcel : format;
  const reportName = `${type}Export`;

  const data = {
    id,
    recipients: email,
    format: fileFormat,
    name: name || reportName,
    recurs,
    status: status || "scheduled",
    source,
    licenceId: licence_id,
    nextReport,
    typeCurrent,
    periodCurrent,
  };

  return data;
}
